import FTLButton from "./components/FTLButton";
export default FTLButton;
//# sourceMappingURL=index.js.map